import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-right-square"><path fillRule="evenodd" clipRule="evenodd" d="M15 4.5V19.5H6.75C5.50736 19.5 4.5 18.4926 4.5 17.25V6.75C4.5 5.50736 5.50736 4.5 6.75 4.5H15ZM21 6.75C21 4.67893 19.3211 3 17.25 3H6.75C4.67893 3 3 4.67893 3 6.75V17.25C3 19.3211 4.67893 21 6.75 21H17.25C19.3211 21 21 19.3211 21 17.25V6.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarSimpleRightSquare;
